module.exports = __webpack_public_path__ + "img/portal-blue.b0df4c2c.svg";